import { GithubSearcher } from '../views/githubSearcher';

export const links = [
  {
    name: 'Github Searcher',
    path: '/github-repo-searcher',
    component: GithubSearcher,
  },
];
